import { render, staticRenderFns } from "./m-page.vue?vue&type=template&id=5bf94b11"
import script from "./m-page.vue?vue&type=script&lang=js"
export * from "./m-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports